var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscordLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_48327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.97812 17.6633H14.8607L14.2931 15.8258C14.3773 15.8991 19.1615 20 19.1615 20V2.0625C19.1048 0.9475 18.1448 0 16.9548 0L2.98229 0.0025C1.79312 0.0025 0.828125 0.951667 0.828125 2.06667V15.6C0.828125 16.7758 1.79146 17.6633 2.97812 17.6633ZM11.7681 4.73583L11.7407 4.74583L11.7507 4.73583H11.7681ZM5.40896 5.79333C6.93646 4.68167 8.35232 4.735 8.35232 4.735L8.46646 4.8475C6.59729 5.29333 5.74979 6.12833 5.74979 6.12833C5.83646 6.11 9.61066 3.9325 14.184 6.18333C14.184 6.18333 13.3348 5.4025 11.5807 4.9025L11.7357 4.75C11.9781 4.75083 13.2615 4.79583 14.6348 5.8C14.6348 5.8 16.1715 8.425 16.1715 11.65C16.1207 11.5883 15.2181 13.0383 12.8957 13.0883C12.8957 13.0883 12.5023 12.6433 12.2223 12.255C13.5807 11.865 14.089 11.085 14.089 11.085C11.4448 12.75 9.12732 12.49 6.35479 11.365C6.32896 11.365 6.31729 11.3533 6.30396 11.34V11.335C6.29062 11.3225 6.27896 11.31 6.25312 11.31H6.20312C6.03312 11.1983 5.91979 11.1433 5.91979 11.1433C5.91979 11.1433 6.42729 11.9233 7.73146 12.3133C7.38899 12.7041 7.04979 13.1483 7.04979 13.1483C4.72813 13.0933 3.88146 11.6433 3.88146 11.6433C3.88146 8.41333 5.40896 5.79333 5.40896 5.79333Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9188 10.6427C12.5112 10.6427 12.9937 10.1427 12.9937 9.52599C12.9937 8.91345 12.5138 8.41345 11.9188 8.41345V8.41599C11.3288 8.41599 10.8454 8.91432 10.8438 9.53099C10.8438 10.1427 11.3262 10.6427 11.9188 10.6427Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.075 10.6427C8.66747 10.6427 9.15 10.1427 9.15 9.52599C9.15 8.91345 8.6708 8.41345 8.07833 8.41345L8.075 8.41599C7.48247 8.41599 7 8.91432 7 9.53099C7 10.1427 7.48247 10.6427 8.075 10.6427Z",
    fill: "#94A3B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_48327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6667,
    height: 20,
    fill: "white",
    transform: "translate(0.664062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordLogo);
export default __webpack_public_path__ + "static/media/discord_logo.6e069995a6118a55f164416992cc3d24.svg";
export { ForwardRef as ReactComponent };